import React, { useState } from 'react';
import { Alert, Box, Button, Flex, Image, Link, Text, VStack } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { authReturn, authDestination } from './client/authContinuation';
import { signupAddress, signupDestination, clearSignupProof } from './auth/signupEmailFlow';
import './App.css';

export default function ThankYou() {
  const [email] = useState(signupAddress);
  const [busy,setBusy] = useState(false);
  const [notice,setNotice] = useState('');
  const [error,setError] = useState('');
  const target = authReturn();
  const resend = async () => {
    setBusy(true);setError('');setNotice('');
    try {
      const response = await fetch('/api/resend-signup-code',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({email,return_to:target})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Could not send another email. Please try again.');
      clearSignupProof(email);
      setNotice('Check your inbox for the latest email from Pabs. It can take a minute to arrive.');
    } catch (failure) { setError(failure.message); }
    finally { setBusy(false); }
  };
  return <Flex className="start-container" direction={{base:'column',md:'row'}}>
    <Box flex="1.5" minW={0} pr={{base:0,md:'5%'}}>
      <Link as={RouterLink} to="/"><Image src="/images/pablo_logo1.0.svg" alt="Pabs home" boxSize="48px" mb="5%" /></Link>
      <Text as="h1" fontSize={{base:'4xl',md:'6xl'}} fontWeight="bold" letterSpacing="tight" color="brand.900" lineHeight={1.1}>Check your email</Text>
      <Text mt={4} fontSize="lg" color="gray.700" overflowWrap="anywhere">{email ? <>We sent a setup link to <strong>{email}</strong>.</> : 'Open the setup email we sent you.'}</Text>
    </Box>
    <Box className="container-box" minW={0} flex={{base:'none',md:'1'}} mt={{base:6,md:'5%'}}>
      <VStack align="stretch" spacing={5} p="5%">
        <Text color="gray.700">Open the email from Pabs and click the setup link to continue.</Text>
        <Text fontSize="sm" color="gray.700">Can’t find it? Check your spam folder, or send it again.</Text>
        {error && <Alert status="error" role="alert">{error}</Alert>}
        {notice && <Alert status="info" role="status">{notice}</Alert>}
        <Button colorScheme="brand" onClick={resend} isDisabled={!email} isLoading={busy} loadingText="Sending email…">Resend email</Button>
        <Link as={RouterLink} to={signupDestination('/authorization',email,target)} onClick={()=>clearSignupProof(email)} textDecoration="underline" alignSelf="flex-start">Enter a code instead</Link>
        <Link as={RouterLink} to={authDestination('/register',target)} fontSize="sm" textDecoration="underline" alignSelf="flex-start">Use a different email</Link>
      </VStack>
    </Box>
  </Flex>;
}
